import { useMemo, useState } from 'react';

import { SolutionImages } from '@/types/integrations.types';
import images from '@/utils/images';
import OptionalComponent from '@ui/optional-component/optional-component';
import AdminCard from '@ui/cards/admin/admin-card';
import InboundIntegrationModal from './modal/inbound-integration-modal';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';

import './inbound-integration-card.css';

interface InboundIntegrationCardProps {
  solution: string;
}

const InboundIntegrationCard = ({ solution }: InboundIntegrationCardProps) => {
  const [openModal, setOpenModal] = useState(false);

  const logo = useMemo(() => {
    if (solution) {
      if (solution === 'Custom') {
        return images.TellyLogo;
      }
      return SolutionImages.get(solution);
    }
  }, [solution]);

  return (
    <AdminCard className={`inbound-integrations-card`}>
      <div className="integration-header">
        <div className="integration-logo">
          <OptionalComponent display={!!logo}>
            <img src={logo} alt={solution} />
          </OptionalComponent>
        </div>
      </div>
      <div className="integration-text">
        <Text tag="p">{solution}</Text>
        <Text tag="span" className="integration-type-label">
          Inbound integration
        </Text>
      </div>
      <div className="integration-footer">
        <Button
          backgroundColor={getThemeColorCSSVariable()}
          padding="8px 16px"
          width="auto"
          onClick={() => setOpenModal(true)}
          hoverOpacity={0.8}
        >
          <Text
            color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
            className="L2"
          >
            Edit
          </Text>
        </Button>
      </div>
      <OptionalComponent display={openModal}>
        <InboundIntegrationModal solution={solution} handleCloseModal={() => setOpenModal(false)} />
      </OptionalComponent>
    </AdminCard>
  );
};

export default InboundIntegrationCard;
